"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _ui = require("../../ui");
var _transactions = require("../../transactions");
var _Header = require("./Header");
var _excluded = ["paymentTypeOptions", "onTypeChange", "tickers", "type", "onTickersChange", "onSearchInputChange", "onSearchClick", "onReset", "searchValue", "title", "subtitle", "transactions", "dates", "onDateChange", "setMinAmount", "setMaxAmount", "maxAmount", "minAmount", "onDownload", "amountsInvalid"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Component = function Component(_ref) {
  var paymentTypeOptions = _ref.paymentTypeOptions,
    onTypeChange = _ref.onTypeChange,
    tickers = _ref.tickers,
    type = _ref.type,
    onTickersChange = _ref.onTickersChange,
    onSearchInputChange = _ref.onSearchInputChange,
    onSearchClick = _ref.onSearchClick,
    onReset = _ref.onReset,
    searchValue = _ref.searchValue,
    title = _ref.title,
    subtitle = _ref.subtitle,
    transactions = _ref.transactions,
    dates = _ref.dates,
    onDateChange = _ref.onDateChange,
    setMinAmount = _ref.setMinAmount,
    setMaxAmount = _ref.setMaxAmount,
    maxAmount = _ref.maxAmount,
    minAmount = _ref.minAmount,
    onDownload = _ref.onDownload,
    amountsInvalid = _ref.amountsInvalid,
    transactionsTableProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransactionsTable'),
    t = _useTranslation.t;
  var Card = function Card(props) {
    return /*#__PURE__*/_react.default.createElement(_transactions.CardTransaction, _extends({}, props, {
      fullData: true
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_ui.Card, null, /*#__PURE__*/_react.default.createElement(_ui.CardHeader, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ui.CardTitle, {
    tag: _ui.H4
  }, title !== null && title !== void 0 ? title : t('titles.history')), /*#__PURE__*/_react.default.createElement(_ui.CardSubtitle, null, subtitle !== null && subtitle !== void 0 ? subtitle : t('subtitle.history')))), /*#__PURE__*/_react.default.createElement(_ui.CardBody, null, /*#__PURE__*/_react.default.createElement(_Header.Header, {
    onTypeChange: onTypeChange,
    paymentTypeOptions: paymentTypeOptions,
    tickers: tickers,
    type: type,
    onTickersChange: onTickersChange,
    onSearchInputChange: onSearchInputChange,
    onSearchClick: onSearchClick,
    onReset: onReset,
    searchValue: searchValue,
    isLoading: transactionsTableProps.isLoading,
    isCSVLoading: transactionsTableProps.isCSVLoading,
    onDateChange: onDateChange,
    dates: dates,
    onDownload: onDownload,
    setMinAmount: setMinAmount,
    setMaxAmount: setMaxAmount,
    maxAmount: maxAmount,
    minAmount: minAmount,
    amountsInvalid: amountsInvalid
  }), /*#__PURE__*/_react.default.createElement(_transactions.Transactions, _extends({
    transactions: transactions
  }, transactionsTableProps, {
    cardComponent: Card,
    tableComponent: _transactions.AllTransactionsTable
  }))));
};
exports.Component = Component;